/**
 * @file progress.component.tsx
 * @path packages/ui/src/progress.component.tsx
 * @description
 */

import { cn } from "@sirbastians/utils";
import * as React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, value, ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    className={cn(
      // Layout
      "relative h-4 w-full overflow-hidden rounded-full",

      // TRACK STYLE: The "Soft Well"
      // 1. neuro-well: Creates the recessed/groove effect.
      // 2. bg-secondary: Standard background color for wells.
      // 3. border-input: Ensures the track is visible on white backgrounds.
      "neuro-well bg-secondary border border-input",

      className,
    )}
    {...props}
  >
    <ProgressPrimitive.Indicator
      className={cn(
        // INDICATOR STYLE: The "Fill"
        // 1. bg-accent: Uses your Green brand color.
        // 2. shadow-[...]: Adds a subtle white highlight to the top edge,
        //    making the bar look rounded/cylindrical inside the groove.
        "h-full w-full flex-1 bg-accent transition-all",
        "shadow-[inset_0_1px_0_0_rgba(255,255,255,0.4)]",
      )}
      style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
    />
  </ProgressPrimitive.Root>
));
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
